import e_shopping from "../assets/e_shopping.png";
import crwnclothing from "../assets/crwnclothing.png";
import netflex from "../assets/netflex.png";
import lyrics from "../assets/lyrics.png";
import calc from "../assets/calc.png";
import todo from "../assets/todo.png";

const Data = [
  {
    image: e_shopping,
    name: "e-shopping-time",
    tech: "React",
    state_management: "Redux",
    styling: "scss",
    Authintication: "GraphQL & Apollo",
    url: "https://e-shopping-time.netlify.app/",
    code: "https://github.com/kimo2121/e-commerce",
  },
  {
    image: crwnclothing,
    name: "crwn clothing",
    tech: "React",
    state_management: "Redux",
    styling: "Styled components",
    Authintication: "Firebase",
    url: "https://crwn-live.herokuapp.com/",
    code: "https://github.com/kimo2121/Crwn-Clothing",
  },
  {
    image: netflex,
    name: "Netflix clone",
    tech: "React",
    state_management: "local state(Hooks)",
    styling: "Css",
    Authintication: "none",
    url: "https://netflex-clone.herokuapp.com/",
    code: "https://github.com/kimo2121/Netflix-clone",
  },
  {
    image: lyrics,
    name: "Lyrics finder",
    tech: "React",
    state_management: "Context API & Hooks",
    styling: "css",
    Authintication: "none",
    url: "https://high-beats.herokuapp.com/",
    code: "https://github.com/kimo2121/High-beats",
  },
  {
    image: calc,
    name: "Calculator",
    tech: "React",
    state_management: "local state(Hooks)",
    styling: "css",
    Authintication: "none",
    url: "https://ca-culator.herokuapp.com/",
    code: "https://github.com/kimo2121/my-calculator",
  },
  {
    image: todo,
    name: "Todo-app",
    tech: "React",
    state_management: "local state(Hooks)",
    styling: "css",
    Authintication: "none",
    url: "https://youthful-todo-list.netlify.app/",
    code: "https://github.com/kimo2121/todo-list",
  },
];
export default Data;
